import HelperMixin from '../../Shared/HelperMixin.vue';
import PaginationHelper from '../../Shared/PaginationHelper.vue';
import { printExternalPurchaseRequest } from './printExternalPurchaseRequest';

/** رقم فاتورة حقيقي: فيه حرف أو رقم واحد على الأقل — «-» و«...» لا تُعدّ رقماً (نفس قاعدة الخادم). */
function hasInvoiceNumber(value) {
    return /[0-9A-Za-z؀-ۿ]/.test(String(value || ''));
}

export default {
    name: 'ExternalPurchaseRequests',
    mixins: [HelperMixin],
    components: { PaginationHelper },

    async created() {
        await this.CheckLoginStatus();
        if (!this.loginDetails || !this.canViewExternalPurchaseRequestsUi()) {
            this.logout();
            return;
        }
        this.GetInfo();
        if (this.canCreateRequest) {
            this.loadLookups();
        }
    },

    computed: {
        isMinistryUser() {
            return this.canReviewProcurementRequestsUi();
        },
        canCreateRequest() {
            return this.canCreateExternalPurchaseRequestsUi();
        },
        statsCards() {
            return [
                this.statCard('إجمالي طلبات التوريد', this.pages, 'primary', 'ti ti-truck-delivery'),
                this.statCard('إجمالي الكمية الحالية', this.sumWhere(this.Info, item => item.totalQty), 'info', 'ti ti-box-multiple'),
                this.statCard('طلبات مرسلة', this.countWhere(this.Info, item => this.matchStatus(item, [2], ['مرسل'])), 'warning', 'ti ti-send'),
                this.statCard('طلبات معتمدة', this.countWhere(this.Info, item => this.matchStatus(item, [3], ['معتمد'])), 'success', 'ti ti-circle-check'),
            ];
        }
    },

    data() {
        return {
            pageNo: 1,
            pageSize: 10,
            pages: 0,
            Search: '',
            statusFilter: 0,
            Info: [],
            detail: null,
            detailDialog: false,
            createDialog: false,
            reviewDialog: false,
            products: [],
            // الأصناف المختارة في البنود — تبقى معروفة ولو خرجت من نتائج البحث.
            chosenProducts: {},
            productSearchLoading: false,
            suppliers: [],
            branches: [],
            createForm: {
                branchesId: null,
                supplierCustomersId: null,
                enforceFormularyOnly: true,
                note: '',
                invoiceFileName: '',
                invoiceFileBase64: '',
                lines: []
            },
            reviewForm: {
                id: 0,
                approve: true,
                note: ''
            },
            supplierDialog: false,
            supplierForm: { name: '', phone: '', descriptions: '' },
            receiveDialog: false,
            receiveForm: {
                requestId: 0,
                invoiceNumber: '',
                invoiceDate: '',
                note: '',
                invoiceFileName: '',
                invoiceFileBase64: '',
                lines: []
            }
        };
    },

    methods: {
        requestCode(item) {
            if (!item) return '-';
            return item.code || item.requestCode || `EPR-${item.id}`;
        },
        supplierMetaText(item) {
            if (!item) return 'بدون مورد محدد';
            return item.note || `إجمالي الكمية ${item.totalQty || 0}`;
        },
        GetInfo(pageNo) {
            this.pageNo = pageNo || 1;
            this.$blockUI.Start();
            this.$http.GetExternalPurchaseRequests(this.pageNo, this.pageSize, this.Search, this.statusFilter)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.Info = response.data.info || [];
                    this.pages = response.data.count || 0;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                    this.Info = [];
                    this.pages = 0;
                });
        },
        loadLookups() {
            this.$http.GetAllBranches()
                .then((response) => {
                    this.branches = response.data.info || response.data || [];
                })
                .catch(() => {
                    this.branches = [];
                });

            // بحث عن بُعد: تُجلب أول دفعة فقط، ثم ما يطابق ما يكتبه المستخدم.
            // تحميل السجل كاملاً كان يثقل فتح الشاشة كلما نمت المنتجات.
            this.searchProducts('');

            this.$http.GetAllSuppliers()
                .then((response) => {
                    this.suppliers = response.data.info || response.data || [];
                })
                .catch(() => {
                    this.suppliers = [];
                });
        },
        openSupplierDialog() {
            this.supplierForm = { name: '', phone: '', descriptions: '' };
            this.supplierDialog = true;
        },

        /** إضافة مورد ثم اختياره فوراً في الطلب — حتى لا يفقد المستخدم ما أدخله. */
        submitSupplier() {
            const name = String(this.supplierForm.name || '').trim();
            const phone = String(this.supplierForm.phone || '').trim();
            if (!name) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'أدخل اسم المورد.');
                return;
            }
            if (!phone) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'أدخل رقم هاتف المورد.');
                return;
            }

            this.$blockUI.Start();
            this.$http.AddSuppliers({ Name: name, Phone: phone, Descriptions: this.supplierForm.descriptions || null })
                .then(() => {
                    // نعيد جلب القائمة ثم نختار المورد المضاف بالاسم — الخادم لا يعيد معرّفه.
                    return this.$http.GetAllSuppliers().then((response) => {
                        this.$blockUI.Stop();
                        this.suppliers = (response.data && response.data.info) || [];
                        const added = this.suppliers.find((x) => String(x.name).trim() === name);
                        if (added) this.createForm.supplierCustomersId = added.id;
                        this.supplierDialog = false;
                        this.$helper.ShowMessage('success', 'تم', added
                            ? 'تمت إضافة المورد واختياره في الطلب.'
                            : 'تمت إضافة المورد — اختره من القائمة.');
                    });
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'تعذر إضافة المورد.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },

        openCreateDialog() {
            this.createForm = {
                branchesId: null,
                supplierCustomersId: null,
                enforceFormularyOnly: true,
                note: '',
                invoiceFileName: '',
                invoiceFileBase64: '',
                lines: []
            };
            this.addLine();
            this.createDialog = true;
        },
        // قراءة ملف الفاتورة كـ base64 — الرفع اختياري بنص المتطلب.
        onInvoiceFileChosen(event, form) {
            const file = event && event.target && event.target.files ? event.target.files[0] : null;
            if (!file) {
                form.invoiceFileName = '';
                form.invoiceFileBase64 = '';
                return;
            }
            if (file.size > 10 * 1024 * 1024) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'حجم ملف الفاتورة يتجاوز 10MB.');
                event.target.value = '';
                return;
            }
            const reader = new FileReader();
            reader.onload = () => {
                form.invoiceFileName = file.name;
                form.invoiceFileBase64 = String(reader.result || '');
            };
            reader.readAsDataURL(file);
        },
        addLine() {
            this.createForm.lines.push({
                productsId: null,
                quantity: 1,
                lineNote: ''
            });
        },
        removeLine(index) {
            this.createForm.lines.splice(index, 1);
        },
        clampQty(line) {
            let q = Number(line.quantity);
            if (isNaN(q) || q < 1) q = 1;
            line.quantity = q;
        },
        /** فتح شاشة طلب إضافة منتج في تبويب جديد — حتى لا يضيع ما كُتب في الطلب هنا. */
        goToProductAddition() {
            window.open('/ProductAdditionRequests', '_blank');
        },

        /**
         * بحث عن بُعد. ويُحتفظ بالأصناف المختارة في chosenProducts لأن نتائج البحث
         * تُستبدل مع كل كلمة جديدة — فلولا الحفظ لاختفى اسم صنف اختاره المستخدم
         * قبل قليل وظهر مكانه رقمه.
         */
        searchProducts(query) {
            this.productSearchLoading = true;
            return this.$http.LookupProducts(query || null, 30)
                .then((response) => {
                    this.productSearchLoading = false;
                    const rows = (response.data && response.data.info) || [];
                    this.products = this.mergeChosen(rows);
                })
                .catch(() => {
                    this.productSearchLoading = false;
                    this.products = this.mergeChosen([]);
                });
        },

        /** نتائج البحث + كل صنف مختار في بنود الطلب، بلا تكرار. */
        mergeChosen(rows) {
            const seen = new Set(rows.map((x) => Number(x.id)));
            const extra = Object.values(this.chosenProducts)
                .filter((x) => !seen.has(Number(x.id)));
            return rows.concat(extra);
        },

        /** يُستدعى عند اختيار صنف في بند — يثبّته حتى لا يضيع مع البحث التالي. */
        rememberChosen(line) {
            const id = Number(line.productsId);
            if (!id) return;
            const row = (this.products || []).find((x) => Number(x.id) === id);
            if (row) this.$set(this.chosenProducts, String(id), row);
        },

        getProductName(id) {
            const row = this.findProduct(id);
            return row ? row.name : '-';
        },
        productIsFormulary(id) {
            const row = this.findProduct(id);
            return !!(row && row.isOnNationalFormulary);
        },
        findProduct(id) {
            const key = Number(id);
            if (!key) return null;
            return (this.products || []).find((x) => Number(x.id) === key)
                || this.chosenProducts[String(key)]
                || null;
        },
        // «غير مختار» تعني null/undefined فقط. المعرّف 0 قيمة مشروعة في هذه القاعدة
        // (الجداول مزروعة بـ IDENTITY_INSERT من الصفر)، وفحص falsy كان يعتبره فارغاً
        // فيرفض مورداً مختاراً فعلاً ويعرض اسمه في الحقل.
        isChosen(value) {
            return value !== null && value !== undefined && value !== '';
        },
        submitCreate() {
            // موظف المرفق: الخادم يسجل الطلب باسم مرفقه تلقائياً ولا يحتاج اختيار مرفق.
            if (!this.isFacilityEmployeeRole() && !this.isChosen(this.createForm.branchesId)) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر المرفق المستفيد قبل إرسال طلب التوريد.');
                return;
            }
            if (!this.isChosen(this.createForm.supplierCustomersId)) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'اختر المورد من قائمة الموردين قبل إرسال الطلب.');
                return;
            }

            const lines = (this.createForm.lines || [])
                .filter((x) => x.productsId && Number(x.quantity) > 0)
                .map((x) => ({
                    productsId: Number(x.productsId),
                    quantity: Number(x.quantity),
                    lineNote: x.lineNote || null
                }));
            if (!lines.length) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'أضف بند توريد واحداً على الأقل.');
                return;
            }
            // فاتورة المورد إجبارية عند الإنشاء (طلب إدارة الصيدلة 2026-10-06).
            if (!this.createForm.invoiceFileBase64) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'ملف فاتورة المورد مطلوب — أرفقه (PDF أو صورة) قبل حفظ الطلب.');
                return;
            }
            const body = {
                // `|| null` كان يحوّل المعرّف 0 إلى null فيصل الطلب للخادم بلا مورد.
                branchesId: this.isChosen(this.createForm.branchesId) ? this.createForm.branchesId : null,
                supplierCustomersId: this.isChosen(this.createForm.supplierCustomersId) ? this.createForm.supplierCustomersId : null,
                enforceFormularyOnly: !!this.createForm.enforceFormularyOnly,
                note: this.createForm.note || null,
                invoiceFileName: this.createForm.invoiceFileName || null,
                invoiceFileBase64: this.createForm.invoiceFileBase64 || null,
                lines
            };
            this.$blockUI.Start();
            this.$http.CreateExternalPurchaseRequest(body)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data.message || 'تم إرسال طلب التوريد.');
                    this.createDialog = false;
                    this.GetInfo(1);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        openDetail(item) {
            this.$blockUI.Start();
            this.$http.GetExternalPurchaseRequest(item.id)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.detail = response.data.info;
                    this.detailDialog = true;
                })
                .catch(() => {
                    this.$blockUI.Stop();
                });
        },
        openReview(approve) {
            if (!this.detail) return;
            this.reviewForm = {
                id: this.detail.id,
                approve,
                note: ''
            };
            this.reviewDialog = true;
        },
        submitReview() {
            this.$blockUI.Start();
            this.$http.ReviewExternalPurchaseRequest(this.reviewForm)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.$helper.ShowMessage('success', 'تم', response.data);
                    this.reviewDialog = false;
                    this.detailDialog = false;
                    this.detail = null;
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        openVoucher(voucher) {
            this.openStockVoucher(voucher);
        },
        openReceiveDialog() {
            if (!this.detail || !this.detail.canReceive) return;
            this.receiveForm = {
                requestId: this.detail.id,
                invoiceNumber: '',
                invoiceDate: '',
                note: '',
                invoiceFileName: '',
                invoiceFileBase64: '',
                // استلام كامل: البنود مقفولة على كميات الطلب المعتمدة.
                lines: (this.detail.lines || []).map((l) => ({
                    externalPurchaseLineId: l.id,
                    productName: l.productName,
                    quantity: l.quantity,
                    requiresExpiryDate: !!l.requiresExpiryDate,
                    batchNumber: '',
                    expiryDate: '',
                    unitPrice: null
                }))
            };
            this.receiveDialog = true;
        },
        submitReceive() {
            // فاتورة الشراء إجبارية (طلب إدارة الصيدلة 2026-10-05): رقمها يربط الكميات بمصدرها.
            if (!hasInvoiceNumber(this.receiveForm.invoiceNumber)) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'رقم فاتورة المورد مطلوب — اكتبه كما هو على الفاتورة.');
                return;
            }
            const missingBatch = (this.receiveForm.lines || []).find((l) => !String(l.batchNumber || '').trim());
            if (missingBatch) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'رقم التشغيلة مطلوب لكل صنف: ' + missingBatch.productName);
                return;
            }
            const missingExpiry = (this.receiveForm.lines || []).find((l) => l.requiresExpiryDate && !l.expiryDate);
            if (missingExpiry) {
                this.$helper.ShowMessage('warning', 'تنبيه', 'تاريخ الصلاحية مطلوب للصنف: ' + missingExpiry.productName);
                return;
            }
            // تاريخ غير معقول (سنة من رقمين مثلاً) يُرفض قبل الإرسال.
            const badExpiry = (this.receiveForm.lines || [])
                .map((l) => this.expiryDateProblem(l.expiryDate, l.productName))
                .find((p) => p);
            if (badExpiry) {
                this.$helper.ShowMessage('warning', 'تنبيه', badExpiry);
                return;
            }
            const badInvoiceDate = this.expiryDateProblem(this.receiveForm.invoiceDate, null, 'تاريخ الفاتورة');
            if (badInvoiceDate) {
                this.$helper.ShowMessage('warning', 'تنبيه', badInvoiceDate);
                return;
            }

            const body = {
                invoiceNumber: String(this.receiveForm.invoiceNumber || '').trim(),
                invoiceDate: this.receiveForm.invoiceDate || null,
                note: this.receiveForm.note || null,
                invoiceFileName: this.receiveForm.invoiceFileName || null,
                invoiceFileBase64: this.receiveForm.invoiceFileBase64 || null,
                lines: (this.receiveForm.lines || []).map((l) => ({
                    externalPurchaseLineId: l.externalPurchaseLineId,
                    batchNumber: String(l.batchNumber || '').trim(),
                    expiryDate: l.expiryDate || null,
                    unitPrice: l.unitPrice === null || l.unitPrice === '' ? null : Number(l.unitPrice)
                }))
            };
            this.$blockUI.Start();
            this.$http.ReceiveExternalPurchaseRequest(this.receiveForm.requestId, body)
                .then((response) => {
                    this.$blockUI.Stop();
                    this.receiveDialog = false;
                    this.$helper.ShowMessage('success', 'تم الاستلام',
                        (response.data && response.data.message ? response.data.message : 'تم الاستلام.')
                        + (response.data && response.data.voucherCode ? ' سند: ' + response.data.voucherCode : ''));
                    this.openDetail({ id: this.receiveForm.requestId });
                    this.GetInfo(this.pageNo);
                })
                .catch((err) => {
                    this.$blockUI.Stop();
                    const msg = err.response && err.response.data ? err.response.data : 'خطأ';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        printDetail() {
            if (!this.detail || !this.detail.canPrint) return;
            this.$http.MarkExternalPurchaseRequestPrinted(this.detail.id)
                .then(() => {
                    const opened = printExternalPurchaseRequest(this.detail);
                    if (!opened) {
                        this.$helper.ShowMessage('warning', 'تنبيه', 'تعذر فتح نافذة الطباعة.');
                        return;
                    }
                    this.openDetail({ id: this.detail.id });
                })
                .catch((err) => {
                    const msg = err.response && err.response.data ? err.response.data : 'تعذر تسجيل الطباعة.';
                    this.$helper.ShowMessage('error', 'خطأ', msg);
                });
        },
        statusBadgeClass(status) {
            if (Number(status) === 5) return 'bg-label-info';
            if (Number(status) === 3) return 'bg-label-success';
            if (Number(status) === 4) return 'bg-label-danger';
            if (Number(status) === 2) return 'bg-label-warning';
            return 'bg-label-secondary';
        },
        workflowStageText(item) {
            if (!item) return '-';
            if (Number(item.status) === 5) return 'تم الاستلام وإضافة الكميات لمخزن المرفق';
            if (Number(item.status) === 3) return 'بانتظار تسجيل فاتورة الاستلام في مخزن المرفق';
            if (item.linkedVoucherCode) return `تم إنشاء سند إدخال: ${item.linkedVoucherCode}`;
            if (Number(item.status) === 4) return 'تم إقفال الطلب بالرفض';
            if (Number(item.status) === 2) return 'بانتظار المراجعة والاعتماد';
            return 'مسودة';
        },
        detailWorkflowMessage() {
            if (!this.detail) return '';
            if (Number(this.detail.status) === 5 && this.detail.receiving) {
                return `تم الاستلام بموجب فاتورة الاستلام ${this.detail.receiving.code} وإضافة الكميات لمخزن المرفق.`;
            }
            if (Number(this.detail.status) === 3) {
                // الطلبات الجديدة لا تمر بإدارة الصيدلة؛ لا نقول «معتمد منها» إلا لطلب قديم اعتمدته فعلاً.
                const reviewed = this.detail.lastDecision && Number(this.detail.lastDecision.decision) !== 3;
                const head = reviewed ? 'الطلب معتمد من إدارة الصيدلة' : 'الطلب جاهز للاستلام';
                return this.detail.canReceive
                    ? head + ' — سجّل فاتورة الاستلام برقم فاتورة المورد لإدخال المشتريات لمخزن المرفق.'
                    : head + ' — بانتظار تسجيل فاتورة الاستلام في المرفق (من يملك صلاحية اعتماد الجرد).';
            }
            if (Number(this.detail.status) === 4) {
                return 'تم رفض الطلب من إدارة الصيدلة. سبب الرفض موضّح أدناه.';
            }
            if (Number(this.detail.status) === 2) {
                return 'الطلب قيد مراجعة إدارة الصيدلة (قبول أو رفض). بعد الاعتماد يسجّل المرفق فاتورة استلام المشتريات لتدخل الكميات مخزنه.';
            }
            return 'الطلب ما زال في مرحلة أولية.';
        },
        detailWorkflowAlertClass() {
            if (!this.detail) return 'alert-secondary';
            if (Number(this.detail.status) === 5) return 'alert-success';
            if (Number(this.detail.status) === 3) return 'alert-success';
            if (Number(this.detail.status) === 4) return 'alert-danger';
            if (Number(this.detail.status) === 2) return 'alert-warning';
            return 'alert-secondary';
        },
        decisionBadgeClass(decision) {
            if (decision === 2) return 'bg-label-success';
            if (decision === 3) return 'bg-label-danger';
            return 'bg-label-warning';
        }
    }
};
